<template>
    <div class="product_layout p-t-0">
      <el-row class="product_tab_pane" :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-for="(product_item, index) in this.productsProp" :key="index">
          <el-card shadow="always" class="p-10 product_card m-l-10 m-t-10">
            <!-- <el-button class="flr product_wishlist_button" type="primary" icon="el-icon-star-on" circle>
            </el-button> -->
            <a @click="goToProductDetail(product_item.id)" class="cursor">
              <img class="m-t-20" style="width: 200px; height: 270px" :src="'https://dmafilemanagement.s3.ap-southeast-1.amazonaws.com/images/' + product_item.img_url" fit="cover" />
            </a>
          </el-card>
          <div class="product_information p-15">
            <span class="product_name m-t-0">{{product_item.name}}</span>
            <span class="flr" :style="'color: ' + textColor()">{{product_item.price | formatCurrency}}</span>
            <!-- <span class="flr" :style="'color:'+this.textColor()">{{product_item.price | formatCurrency}}</span> -->
            <span>{{ product_item.branch_products.balance }}</span>
            <!-- <p class="product_description m-t-10">{{product_item.description}}</p> -->
             <br/>
            <el-button class="signup_button m-t-20" icon="el-icon-shopping-cart-full" @click="add_product_to_basket(product_item)">
              {{ $t('addtocard') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
     </div>
  </template>
<script>
import {
  mapGetters
} from 'vuex'
export default {
  name: 'CategoryComponent',
  computed: mapGetters({
    categoriesGetter: 'categoriesGetter'
  }),
  props: {
    productsProp: Array
  },

  data: function () {
    return {
      productDetail: {
        name: '',
        description: '',
        price: 0,
        product_code: 0,
        img_url: '',
        count: 1,
        categories: {
          category_name: 'хоосон'
        }
      }
    }
  },
  created () {
  },
  methods: {
    add_product_to_basket (data) {
      const basketItem = {
        id: data.id,
        product_name: data.name,
        item_price: data.price,
        item_count: data.item_count,
        img_url: data.img_url,
        product_id: data.id
      }
      this.$store.dispatch('add_basket', basketItem)
      this.$notify({
        title: 'Амжилттай',
        message: 'Таны сонгосон бүтээгдэхүүн сагсанд нэмэгдлээ',
        type: 'success',
        position: 'top-right'
      })
    },
    goToProductDetail (productID) {
      this.$router.push({ path: '/productDetail', query: { product_id: productID } })
    },
    textColor () {
      if (window.location.hostname === 'www.iteever.mn') {
        return '#5E1EE5'
      } else if (window.location.hostname === 'www.eruulhun.com') {
        return '#64a29f'
      } else if (window.location.hostname === 'localhost') {
        return '#64a29f'
      }
    }
  }
}

</script>

<style>

</style>
